class StickyATC extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-sticky-atc-button]');
    this.buttonText = this.querySelector('[data-sticky-atc-button-text]');
    this.priceElement = this.querySelector('[data-sticky-atc-price]');

    this.handleClick = this.handleClick.bind(this);
    this.sync = this.sync.bind(this);
    this.updateVisibility = this.updateVisibility.bind(this);

    this.button?.addEventListener('click', this.handleClick);

    window.addEventListener('scroll', this.updateVisibility, { passive: true });
    window.addEventListener('resize', this.updateVisibility);

    this.observeProductChanges();
    this.sync();
    this.updateVisibility();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
    window.removeEventListener('scroll', this.updateVisibility);
    window.removeEventListener('resize', this.updateVisibility);
    this.observer?.disconnect();
    document.body.classList.remove('sticky-atc-visible');
  }

  get mainSubmitButton() {
    return document.querySelector(this.dataset.submitSelector);
  }

  get priceSource() {
    return document.querySelector(this.dataset.priceSelector);
  }

  get productInfo() {
    return document.querySelector(this.dataset.productInfoSelector);
  }

  handleClick(event) {
    event.preventDefault();

    const submitButton = this.mainSubmitButton;
    if (!submitButton) return;

    const isUnavailable =
      submitButton.disabled ||
      submitButton.hasAttribute('disabled') ||
      submitButton.getAttribute('aria-disabled') === 'true';

    if (isUnavailable && !submitButton.classList.contains('loading')) {
      submitButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    this.button.disabled = true;
    this.buttonText.textContent = 'Adding...';

    submitButton.click();

    setTimeout(this.sync, 500);
  }

  observeProductChanges() {
    if (!this.productInfo) return;

    this.observer = new MutationObserver(() => {
      window.requestAnimationFrame(() => {
        this.sync();
        this.updateVisibility();
      });
    });

    this.observer.observe(this.productInfo, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class', 'value'],
    });
  }

  sync() {
    const submitButton = this.mainSubmitButton;
    if (!submitButton || !this.button) return;

    const sourceText = submitButton.querySelector('span')?.textContent?.trim();
    const isLoading = submitButton.classList.contains('loading');
    const isDisabled =
      submitButton.disabled ||
      submitButton.hasAttribute('disabled') ||
      submitButton.getAttribute('aria-disabled') === 'true';

    this.button.disabled = isDisabled;

    if (this.buttonText) {
      this.buttonText.textContent = isLoading
        ? 'Adding...'
        : sourceText || 'Add to cart';
    }

    const priceText = this.priceSource
      ?.querySelector('.price-item--sale, .price-item--regular, .price__regular .price-item, .price__sale .price-item')
      ?.textContent
      ?.trim();

    if (priceText && this.priceElement) {
      this.priceElement.textContent = priceText;
    }
  }

  updateVisibility() {
    const submitButton = this.mainSubmitButton;

    if (!submitButton || window.innerWidth >= 750) {
      this.classList.remove('is-visible');
      document.body.classList.remove('sticky-atc-visible');
      return;
    }

    const rect = submitButton.getBoundingClientRect();
    const shouldShow = rect.bottom < 0;

    this.classList.toggle('is-visible', shouldShow);
    document.body.classList.toggle('sticky-atc-visible', shouldShow);
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyATC);
}